import type { JSXElementConstructor } from 'react'

import { OrderType } from '~/constants/SOAPStates'
import InventoryItemActionsLineItem from '~/utils/actions/InventoryItemActionsLineItem'
import LabTestActionsLineItem from '~/utils/actions/LabTestActionsLineItem'
import PrescriptionItemActionsLineItem from '~/utils/actions/PrescriptionItemActionsLineItem'
import ProcedureActionsLineItem from '~/utils/actions/ProcedureActionsLineItem'

export const LineItemComponentsActions: Partial<
  Record<OrderType, JSXElementConstructor<any>>
> = {
  [OrderType.INVENTORY]: InventoryItemActionsLineItem,
  [OrderType.PROCEDURE]: ProcedureActionsLineItem,
  [OrderType.LAB_TEST]: LabTestActionsLineItem,
  [OrderType.PRESCRIPTION]: PrescriptionItemActionsLineItem,
}
